export default __webpack_public_path__ + "static/media/appleLoginLogo.729fa412.svg";